import { createFileRoute } from "@tanstack/react-router";

import { AdminKakekomiDetailPage } from "@/features/admin/kakekomi/kakekomi-detail-page";
import { adminKakekomiEventQueryOptions } from "@/features/admin/kakekomi/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/kakekomi/$id/")({
  staticData: { crumb: { label: "予約状況" } },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(adminKakekomiEventQueryOptions(params.id)),
  component: function Page() {
    const { id } = Route.useParams();
    return <AdminKakekomiDetailPage id={id} />;
  },
});
